import React, { Component } from 'react';

interface State {
  error: string | null;
}

interface Props {
  message?: string;
}

export default class MyErrorBoundary extends Component<Props, State> {
  static getDerivedStateFromError(error: Error) {
    return { error: error.message };
  }

  state = {
    error: null,
  };

  componentDidCatch(error: any) {
    console.log('error', error);
  }

  render() {
    if (this.state.error) {
      return <span style={{ color: 'red' }}>{this.props.message || this.state.error}</span>;
    }
    return this.props.children;
  }
}
